import { postNewsletterSubscribe } from '@yme/api';
import { setIsModalShowed } from '@yme/modals/actions';
import { MODALS, ModalState } from '@yme/modals/constants';
import { getFormattedLanguageRoot } from '@yme/utils/common';
import { setNewsletterIsLoading } from './actions';
export const subscribeNewsletter = (ymeInterests, racingInterests, t) => async (dispatch, getState) => {
    const { common: { language, languageRootPath }, newsletter: { email }, } = getState();
    dispatch(setNewsletterIsLoading(true));
    try {
        await postNewsletterSubscribe(email, getFormattedLanguageRoot(language), languageRootPath, ymeInterests, racingInterests);
        dispatch(setIsModalShowed({
            type: MODALS.GENERAL_MESSAGE_MODAL,
            data: {
                state: ModalState.SUCCESS,
                title: t('newsletter_thankYouForSubscription_header'),
                description: t('newsletter_thankYouForSubscription_message'),
                primaryButtonContent: t('common_gotIt_button'),
            },
        }));
    }
    catch {
        dispatch(setIsModalShowed({
            type: MODALS.GENERAL_MESSAGE_MODAL,
            data: {
                state: ModalState.ERROR,
                title: t('common_popUpError_header'),
                description: t('newsletter_subscriptionProcessFailed_message'),
                primaryButtonContent: t('common_gotIt_button'),
            },
        }));
    }
    finally {
        dispatch(setNewsletterIsLoading(false));
    }
};
